<template>
  <div>
    <LayoutContent>
      <SectionTitle :label="$t('label.editAddress')" />
      <section>
        <v-container>
          <v-row no-gutters justify="center">
            <v-col :xs="12" :sm="6" :cols="12">
              <v-form v-model="isValid" @submit.prevent="submitForm" class="elevation-4 rounded-lg pa-4">
                <v-text-field v-model="form.address_name" :label="$t('label.addressName')" :rules="$rules.requiredRules" :hint="$t('hint.addressName')" persistent-hint />
                <v-text-field v-model="form.receiver_name" :label="$t('label.receiverName')" :rules="$rules.requiredRules" />
                <v-text-field v-model="form.contact_no" :label="$t('label.contactNo')" :rules="$rules.requiredRules" :hint="$t('hint.contactNo')" persistent-hint />
                <v-text-field v-model="form.floor_unit_number" :label="$t('label.floorOrUnitNumber')" :rules="$rules.requiredRules" :hint="$t('hint.floorOrUnitNumber')" persistent-hint />
                <v-text-field v-model="form.address" :label="$t('label.address')" :rules="$rules.requiredRules" />
                <v-text-field v-model="form.postcode" :label="$t('label.postcode')" :rules="$rules.requiredRules" :hint="$t('hint.postcode')" persistent-hint />
                <v-switch v-model="form.default_delivery_address" :label="$t('label.makeDefaultShippingAddress')" inset true-value="1" false-value="0"></v-switch>
                <v-switch v-model="form.default_billing_address" :label="$t('label.makeDefaultBillingAddress')" inset true-value="1" false-value="0"></v-switch>
              </v-form>
            </v-col>
          </v-row>
        </v-container>
      </section>
    </LayoutContent>
    <bottom-bar>
      <v-container class="py-3 d-flex align-center justify-center">
        <app-button class="mr-12" :label="$t('button.cancel')" @click="goBack" />
        <app-button :label="$t('button.saveAddress')" :disabled="!isValid" @click="submitForm" />
      </v-container>
    </bottom-bar>
  </div>
</template>

<script>
import { mapActions } from 'vuex'
import LayoutContent from '@/views/layouts/LayoutContent.vue'
import SectionTitle from '@/components/SectionTitle.vue'

export default {
  components: { LayoutContent, SectionTitle },
  data: () => ({
    isValid: false,
    form: {}
  }),
  created() {
    this.fetchDetail()
  },
  methods: {
    ...mapActions('auth', ['getAddressDetail', 'editAddress']),
    async fetchDetail() {
      await this.getAddressDetail(this.$route.params.addressId).then(({ address }) => {
        this.form = {
          address_name: address.address_name,
          receiver_name: address.receiver_name,
          country_id: address.country === 'Malaysia' ? 1 : 2,
          contact_no: address.country === 'Malaysia' ? `60${address.contact_no}` : `65${address.contact_no}`,
          floor_unit_number: address.floor_unit_number,
          address: address.address,
          postcode: address.postcode,
          default_delivery_address: address.default_delivery_address ? '1' : '0',
          default_billing_address: address.default_billing_address ? '1' : '0'
        }
      })
    },
    async submitForm() {
      this.form.country_id = this.form.contact_no.slice(0, 2) === '60' ? 1 : 2
      this.form.contact_no = this.form.contact_no.slice(2)
      await this.editAddress({ id: this.$route.params.addressId, form: this.form })
        .then(() => {
          this.$toast.success(this.$t('message.editAddressSuccessfully'))
          this.goBack()
        })
        .catch(() => {
          this.$toast.error(this.$t('message.editAddressFailed'))
        })
    },
    goBack() {
      this.$router.go(-1)
    }
  }
}
</script>

<style lang="scss">
::v-deep .v-input {
  .v-input__slot::before {
    border-style: none;
  }

  .v-label {
    font-weight: bold;
    color: var(--v-secondary-lighten2);
  }
}
</style>
